/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies
 */
import {
    Defs,
    G,
    Path,
    Rect,
    SVG,
} from '@wordpress/primitives';



export const checkIcon = (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <Path d="M9 18.6L3.5 13l1-1L9 16.4l9.5-9.9 1 1z" />
    </SVG>
);

export const alignBottom = (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <Path d="M15 4H9v11h6V4zM4 18.5V20h16v-1.5H4z" />
    </SVG>
);

export const alignCenter = (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <Path d="M20 11h-5V4H9v7H4v1.5h5V20h6v-7.5h5z" />
    </SVG>
);

export const alignTop = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
   <defs>
   </defs>
   <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="101" y="102" width="298" height="20" rx="10" ry="10"/>
   <rect id="Rounded_Rectangle_1_copy" data-name="Rounded Rectangle 1 copy" className="cls-1" x="101" y="379" width="298" height="20" rx="10" ry="10"/>
   <rect id="Rounded_Rectangle_2_copy" data-name="Rounded Rectangle 2 copy" className="cls-1" x="182" y="148" width="46" height="205" rx="19.5" ry="19.5"/>
   <rect id="Rounded_Rectangle_2_copy_2" data-name="Rounded Rectangle 2 copy 2" className="cls-1" x="272" y="148" width="46" height="205" rx="19.5" ry="19.5"/>
 </svg>
);

export const Start = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
    <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="64" y="114" width="372" height="36" rx="18" ry="18"/>
    <rect id="Rounded_Rectangle_1_copy" data-name="Rounded Rectangle 1 copy" className="cls-1" x="194" y="172" width="41" height="244" rx="18" ry="18"/>
    <rect id="Rounded_Rectangle_1_copy_2" data-name="Rounded Rectangle 1 copy 2" className="cls-1" x="275" y="172" width="41" height="141" rx="18" ry="18"/>
  </svg>
);

export const Center = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
   <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="64" y="232" width="372" height="36" rx="18" ry="18"/>
   <rect id="Rounded_Rectangle_1_copy" data-name="Rounded Rectangle 1 copy" className="cls-1" x="195" y="128" width="41" height="244" rx="18" ry="18"/>
   <rect id="Rounded_Rectangle_1_copy_2" data-name="Rounded Rectangle 1 copy 2" className="cls-1" x="262" y="180" width="41" height="141" rx="18" ry="18"/>
 </svg>
);

export const End = (
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="64" y="347" width="372" height="36" rx="18" ry="18"/>
 <rect id="Rounded_Rectangle_1_copy" data-name="Rounded Rectangle 1 copy" className="cls-1" x="193" y="84" width="41" height="244" rx="18" ry="18"/>
 <rect id="Rounded_Rectangle_1_copy_2" data-name="Rounded Rectangle 1 copy 2" className="cls-1" x="276" y="180" width="41" height="141" rx="18" ry="18"/>
</svg>
);

export const Strech = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="64" y="384" width="372" height="36" rx="18" ry="18"/>
 <rect id="Rounded_Rectangle_1_copy_3" data-name="Rounded Rectangle 1 copy 3" className="cls-1" x="64" y="80" width="372" height="36" rx="18" ry="18"/>
 <rect id="Rounded_Rectangle_1_copy" data-name="Rounded Rectangle 1 copy" className="cls-1" x="190" y="137" width="41" height="219" rx="18" ry="18"/>
 <rect id="Rounded_Rectangle_1_copy_2" data-name="Rounded Rectangle 1 copy 2" className="cls-1" x="276" y="137" width="41" height="219" rx="18" ry="18"/>
 </svg>
);

export const OrderStart = (
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <path id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" d="M88,64h2.989a14,14,0,0,1,14,14V422a14,14,0,0,1-14,14H88a14,14,0,0,1-14-14V78A14,14,0,0,1,88,64Z"/>
 <path className="cls-1" d="M426.011,265.977l-223.5.142c10.788,29.72,16.161,49.1,16.728,75.529-24.524-45.547-56.382-69.25-94.877-91.535,38.467-21.393,68.89-47.493,94.761-91.689-1.635,28.722-6.091,46.069-16.966,77.688l223.835-.143Z"/>
</svg>
);

export const OrderEnd = (
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="395" y="64" width="31" height="372" rx="14" ry="14"/>
 <path className="cls-2" d="M73.99,234.023l223.5-.142c-10.788-29.72-16.161-49.1-16.728-75.529,24.524,45.547,56.382,69.25,94.877,91.535-38.467,21.393-68.89,47.493-94.761,91.689,1.635-28.722,6.091-46.069,16.966-77.688l-223.835.143Z"/>
</svg>
);

export const Custom = (
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <circle className="cls-1" cx="250" cy="107" r="40"/>
 <circle id="Ellipse_1_copy" data-name="Ellipse 1 copy" className="cls-1" cx="250" cy="250" r="40"/>
 <circle id="Ellipse_1_copy_2" data-name="Ellipse 1 copy 2" className="cls-1" cx="250" cy="394" r="40"/>
</svg>
);

export const None = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
   <path className="cls-1" d="M137.231,116.182a175,175,0,1,0,246.586,21.05A175,175,0,0,0,137.231,116.182Zm12.062,218.685a131.726,131.726,0,0,1,.773-170.66L317.614,363.03A131.726,131.726,0,0,1,149.293,334.867Zm200.641,0.926L182.386,136.971A131.711,131.711,0,0,1,349.934,335.793Z"/>
   </svg>
);

export const Shrink = (
   
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="240" y="64" width="21" height="372" rx="10.5" ry="10.5"/>
 <path className="cls-2" d="M56.995,247.762l116.336-.069c-5.616-14.437-8.412-23.852-8.708-36.689,12.766,22.125,29.348,33.639,49.385,44.464-20.022,10.392-35.858,23.07-49.324,44.539,0.851-13.952,3.17-22.379,8.831-37.738L57,262.338Z"/>
 <path id="Shape_1_copy" data-name="Shape 1 copy" className="cls-2" d="M442.005,263.238l-116.335.069c5.616,14.437,8.412,23.852,8.708,36.689-12.766-22.125-29.348-33.639-49.385-44.464,20.022-10.392,35.858-23.07,49.324-44.539-0.851,13.952-3.17,22.379-8.831,37.738L442,248.662Z"/>
</svg>
);

export const Grow = (
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="388" y="64" width="21" height="372" rx="10.5" ry="10.5"/>
 <rect id="Rounded_Rectangle_1_copy_3" data-name="Rounded Rectangle 1 copy 3" className="cls-1" x="91" y="64" width="21" height="372" rx="10.5" ry="10.5"/>
 <path className="cls-2" d="M307.005,252.042l-116.335.077c5.616,16.041,8.412,26.5,8.708,40.765-12.766-24.582-29.348-37.376-49.385-49.4,20.022-11.546,35.858-25.633,49.324-49.487-0.851,15.5-3.17,24.865-8.831,41.93L307,235.846Z"/>
 <path id="Shape_1_copy" data-name="Shape 1 copy" className="cls-2" d="M197,235.958l116.335-.077c-5.616-16.041-8.412-26.5-8.708-40.765,12.766,24.582,29.348,37.376,49.385,49.4-20.022,11.546-35.858,25.633-49.324,49.487,0.851-15.5,3.17-24.865,8.831-41.93L197,252.154Z"/>
</svg>
);

export const HorizontalLeft = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
   <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="59" y="64" width="22" height="372" rx="11" ry="11"/>
   <path className="cls-2" d="M441.012,268.521l-250.455.076c12.09,15.9,18.111,26.264,18.747,40.4-27.482-24.361-63.182-37.04-106.32-48.96,43.106-11.442,77.2-25.4,106.189-49.042-1.832,15.362-6.825,24.641-19.012,41.553l250.829-.076Z"/>
 </svg>
   );

export const HorizontalRight = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
   <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="419" y="64" width="22" height="372" rx="11" ry="11"/>
   <path className="cls-2" d="M58.988,231.479l250.455-.076c-12.09-15.9-18.111-26.264-18.747-40.4,27.482,24.361,63.182,37.04,106.32,48.96-43.106,11.442-77.2,25.4-106.189,49.042,1.832-15.362,6.825-24.641,19.012-41.553L59.01,247.53Z"/>
 </svg>
 
);

export const VerticalTop = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="64" y="59" width="372" height="22" rx="11" ry="11"/>
 <path className="cls-2" d="M231.479,441.012L231.4,190.557c-15.9,12.09-26.264,18.111-40.4,18.747,24.361-27.483,37.04-63.182,48.96-106.32,11.442,43.106,25.4,77.2,49.042,106.189-15.362-1.832-24.641-6.825-41.553-19.012L247.53,440.99Z"/>
</svg>
   );

export const VerticalBottom = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
   <rect id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" className="cls-1" x="64" y="419" width="372" height="22" rx="11" ry="11"/>
   <path className="cls-2" d="M268.521,58.988L268.6,309.443c15.9-12.09,26.264-18.111,40.4-18.747-24.361,27.483-37.04,63.182-48.96,106.32-11.442-43.106-25.4-77.2-49.042-106.189,15.362,1.832,24.641,6.825,41.553,19.012L252.47,59.01Z"/>
 </svg>
 
);

export const Bgclr = (
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <path className="cls-1" fillRule="evenodd" fill="#5d5d5e" d="M77,78h62.041V422H77V78Z"/>
 <path id="Rectangle_1_copy_3" data-name="Rectangle 1 copy 3" className="cls-2" fillRule="evenodd" fill="#bbbbbc" d="M360.959,78H423V422H360.959V78Z"/>
 <path id="Rectangle_1_copy" data-name="Rectangle 1 copy" className="cls-3" fillRule="evenodd" fill="#bdbdbe" d="M139.041,78H250V422H139.041V78Z"/>
 <path id="Rectangle_1_copy_2" data-name="Rectangle 1 copy 2" className="cls-4" fillRule="evenodd" fill="#e3e3e5" d="M250,78H360.959V422H250V78Z"/>
</svg>
);

export const BgGraclr = (
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <path className="cls-1" fillRule="evenodd" fill="#5d5d5e" d="M77,78h62.041V422H77V78Z"/>
 <path id="Rectangle_1_copy_3" data-name="Rectangle 1 copy 3" className="cls-2" fillRule="evenodd" fill="#bbbbbc" d="M360.959,78H423V422H360.959V78Z"/>
 <path id="Rectangle_1_copy" data-name="Rectangle 1 copy" className="cls-3" fillRule="evenodd" fill="#bdbdbe" d="M139.041,78H250V422H139.041V78Z"/>
 <path id="Rectangle_1_copy_2" data-name="Rectangle 1 copy 2" className="cls-4" fillRule="evenodd" fill="#e3e3e5" d="M250,78H360.959V422H250V78Z"/>
</svg>
);

export const BgImg = (
   
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <circle className="cls-1" fill="#5d5d5e" cx="137.5" cy="200.5" r="32.5"/>
 <path className="cls-2" fillRule="evenodd" fill="#5d5d5e" d="M320.261,246.989L431,431.6l-98.452,1.416L186,431.918Z"/>
 <path className="cls-2" fill="#5d5d5e" d="M146.8,267L227,420.423l-26.113,9.568L89.012,435.01Z"/>
 <rect className="cls-3" fill="none" stroke="#5d5d5e" stroke-width="15px" x="49" y="103" width="408" height="335" rx="15" ry="15"/>
</svg>
   );

export const ArwLft = (
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <path className="cls-1" fill="#5d5d5e" fillRule="evenodd" d="M447.994,265.555H156.067c14.066,29.692,21.068,49.056,21.787,75.452-32-45.51-73.587-69.206-123.848-91.49,50.261-21.344,90.021-47.395,123.848-91.524-2.158,28.688-7.993,46.013-22.224,77.588H447.994v29.974Z"/>
</svg>
);

export const ArwRgt = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <path className="cls-1" fill="#5d5d5e" fillRule="evenodd" d="M53.006,234.445H344.933c-14.066-29.692-21.068-49.056-21.787-75.452,32,45.51,73.587,69.206,123.848,91.49-50.261,21.344-90.021,47.395-123.848,91.524,2.158-28.688,7.993-46.013,22.224-77.588H53.006V234.445Z"/>
</svg>
 );

export const ArwUp = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <path className="cls-1" fill="#5d5d5e" fillRule="evenodd" d="M235.445,446.994V155.067c-29.692,14.066-49.056,21.068-75.452,21.787,45.51-32,69.206-73.587,91.49-123.848,21.344,50.261,47.395,90.021,91.524,123.848-28.688-2.158-46.013-7.993-77.588-22.224V446.994H235.445Z"/>
</svg>
    );

export const ArwDn = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <path className="cls-1" fill="#5d5d5e" fillRule="evenodd" d="M266.555,53.006V344.933c29.692-14.066,49.056-21.068,75.452-21.787-45.51,32-69.206,73.587-91.49,123.848-21.344-50.261-47.395-90.021-91.524-123.848,28.688,2.158,46.013,7.993,77.588,22.224V53.006h29.974Z"/>
</svg>
);

export const JfCntstr = (
 <svg xmlns="http://www.w3.org/2000/svg" id="Justify_content_more" data-name="Justify content more" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="133" y="284" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="133" y="226" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="107" y="175" width="287" height="36" rx="9" ry="9"/>
</svg>
);

export const JfCntend = (
 <svg xmlns="http://www.w3.org/2000/svg" id="Justify_content_more" data-name="Justify content more" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e"  className="cls-1" x="133" y="175" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e"  className="cls-1" x="133" y="233" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2"  className="cls-2" x="107" y="290" width="287" height="36" rx="9" ry="9"/>
</svg>
);

export const JfCntctr = (
 <svg xmlns="http://www.w3.org/2000/svg" id="Justify_content_more" data-name="Justify content more" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="133" y="174" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="133" y="284" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="107" y="231" width="287" height="36" rx="9" ry="9"/>
</svg>
);

export const JfCntspbtn = (
 <svg xmlns="http://www.w3.org/2000/svg" id="Justify_content_more" data-name="Justify content more" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="133" y="166" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="133" y="291" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="107" y="350" width="287" height="36" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_5" data-name="Rounded Rectangle 5 copy 5" fill="#a1a1a2" className="cls-2" x="107" y="115" width="287" height="36" rx="9" ry="9"/>
</svg>
);

export const JfCntsparnd = (
 <svg xmlns="http://www.w3.org/2000/svg" id="Justify_content_more" data-name="Justify content more" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="133" y="204" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="133" y="255" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="107" y="345" width="287" height="36" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_5" data-name="Rounded Rectangle 5 copy 5" fill="#a1a1a2" className="cls-2" x="107" y="119" width="287" height="36" rx="9" ry="9"/>
</svg>
);

export const JfCntspevn = (
 <svg xmlns="http://www.w3.org/2000/svg" id="Justify_content_more" data-name="Justify content more" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="133" y="189" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="133" y="270" width="235" height="42" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="107" y="345" width="287" height="36" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_5" data-name="Rounded Rectangle 5 copy 5" fill="#a1a1a2" className="cls-2" x="107" y="119" width="287" height="36" rx="9" ry="9"/>
</svg>
);

export const JfCntstr1 = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e"  className="cls-1" x="278" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e"  className="cls-1" x="221" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2"  className="cls-2" x="180" y="91" width="26" height="318" rx="9" ry="9"/>
</svg>
);

export const JfCntctr1 = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="283" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="176" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="236" y="91" width="26" height="318" rx="9" ry="9"/>
</svg>
);

export const JfCntend1 = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="180" y="127" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="237" y="127" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="294" y="91" width="26" height="318" rx="9" ry="9"/>
</svg>
);

// row reverse
export const JfCntstrRR = (
 <svg xmlns="http://www.w3.org/2000/svg" id="Justify_content" data-name="Justify content" width="500" height="500" viewBox="0 0 500 500">
   <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="165" y="128" width="42" height="245" rx="9" ry="9"/>
   <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="221" y="128" width="42" height="245" rx="9" ry="9"/>
   <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="286" y="92" width="26" height="318" rx="9" ry="9"/>
 </svg>
 );
export const JfCntendRR = (
 <svg xmlns="http://www.w3.org/2000/svg" id="Justify_content" data-name="Justify content" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="282" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="226" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="177" y="91" width="26" height="318" rx="9" ry="9"/>
 </svg>
 );    
/************************* */

export const JfCntspbtn1 = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="161" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="300" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="363" y="91" width="26" height="318" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_4" data-name="Rounded Rectangle 5 copy 4" fill="#a1a1a2" className="cls-2" x="112" y="91" width="26" height="318" rx="9" ry="9"/>
</svg>
);
export const JfCntsparnd1 = (
 <svg xmlns="http://www.w3.org/2000/svg" id="Justify_content" data-name="Justify content" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="201" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="258" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="360" y="91" width="26" height="318" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_7" data-name="Rounded Rectangle 5 copy 7" fill="#a1a1a2" className="cls-2" x="114" y="91" width="26" height="318" rx="9" ry="9"/>
</svg>
);

export const JfCntspevn1 = ( 
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5_copy" data-name="Rounded Rectangle 5 copy" fill="#5d5d5e" className="cls-1" x="198" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_3" data-name="Rounded Rectangle 5 copy 3" fill="#5d5d5e" className="cls-1" x="261" y="128" width="42" height="245" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_2" data-name="Rounded Rectangle 5 copy 2" fill="#a1a1a2" className="cls-2" x="354" y="91" width="26" height="318" rx="9" ry="9"/>
 <rect id="Rounded_Rectangle_5_copy_4" data-name="Rounded Rectangle 5 copy 4" fill="#a1a1a2" className="cls-2" x="121" y="91" width="26" height="318" rx="9" ry="9"/>
</svg>
);

export const alignitemstr = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5" data-name="Rounded Rectangle 5" fill="#777778" className="cls-1" x="106" y="62" width="29" height="376" rx="14.5" ry="14.5"/>
 <rect id="Rounded_Rectangle_6" data-name="Rounded Rectangle 6" fill="#5d5d5e" className="cls-2" x="147" y="190" width="149" height="52" rx="24" ry="24"/>
 <rect id="Rounded_Rectangle_6_copy" data-name="Rounded Rectangle 6 copy" fill="#5d5d5e" className="cls-2" x="147" y="258" width="248" height="52" rx="24" ry="24"/>
 </svg>
);

export const alignitemcnt = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5" data-name="Rounded Rectangle 5" fill="#777778" className="cls-1" x="236" y="62" width="29" height="376" rx="14.5" ry="14.5"/>
 <rect id="Rounded_Rectangle_6" data-name="Rounded Rectangle 6" fill="#5d5d5e" className="cls-2" x="173" y="259" width="155" height="52" rx="24" ry="24"/>
 <rect id="Rounded_Rectangle_6_copy" data-name="Rounded Rectangle 6 copy" fill="#5d5d5e" className="cls-2" x="119" y="189" width="262" height="52" rx="24" ry="24"/>
</svg>
);

export const alignitemend = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5" data-name="Rounded Rectangle 5" fill="#777778" className="cls-1" x="367" y="62" width="29" height="376" rx="14.5" ry="14.5"/>
 <rect id="Rounded_Rectangle_6" data-name="Rounded Rectangle 6" fill="#5d5d5e" className="cls-2" x="203" y="198" width="149" height="52" rx="24" ry="24"/>
 <rect id="Rounded_Rectangle_6_copy" data-name="Rounded Rectangle 6 copy" fill="#5d5d5e" className="cls-2" x="104" y="266" width="248" height="52" rx="24" ry="24"/>
</svg>
);

export const alignitemstrech = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_5" data-name="Rounded Rectangle 5" fill="#777778" className="cls-1" x="379" y="62" width="29" height="376" rx="14.5" ry="14.5"/>
 <rect id="Rounded_Rectangle_5_copy_6" data-name="Rounded Rectangle 5 copy 6" fill="#777778" className="cls-1" x="93" y="62" width="29" height="376" rx="14.5" ry="14.5"/>
 <rect id="Rounded_Rectangle_6" data-name="Rounded Rectangle 6" fill="#5d5d5e" className="cls-2" x="139" y="190" width="225" height="52" rx="24" ry="24"/>
 <rect id="Rounded_Rectangle_6_copy" data-name="Rounded Rectangle 6 copy" fill="#5d5d5e" className="cls-2" x="139" y="258" width="225" height="52" rx="24" ry="24"/>
 </svg>
);

export const alignitemstr1 = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
   <rect className="cls-1" x="78" y="142" width="344" height="22" rx="11" ry="11"/>
   <rect className="cls-1" x="201" y="177" width="40" height="182" rx="16" ry="16"/>
   <rect id="Rectangle_8_copy" data-name="Rectangle 8 copy" fill="#5d5d5e" className="cls-1" x="259" y="177" width="40" height="120" rx="16" ry="16"/>
 </svg>
 );

 export const alignitemcnt1 = (
 <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect className="cls-1" x="78" y="239" width="344" height="22" rx="11" ry="11"/>
 <rect className="cls-1" x="200" y="131" width="40" height="238" rx="16" ry="16"/>
 <rect id="Rectangle_8_copy" data-name="Rectangle 8 copy" fill="#5d5d5e" className="cls-1" x="259" y="190" width="40" height="120" rx="16" ry="16"/>
</svg>
 );
 
 export const alignitemend1 = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
   <rect className="cls-1" x="78" y="337" width="344" height="22" rx="11" ry="11"/>
   <rect className="cls-1" x="259" y="142" width="40" height="182" rx="16" ry="16"/>
   <rect id="Rectangle_8_copy" data-name="Rectangle 8 copy" fill="#5d5d5e" className="cls-1" x="201" y="204" width="40" height="120" rx="16" ry="16"/>
 </svg>
 );

 export const alignitemstrech1 = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect className="cls-1" x="92" y="97" width="316" height="22" rx="11" ry="11"/>
 <rect id="Rectangle_7_copy" data-name="Rectangle 7 copy" fill="#5d5d5e" className="cls-1" x="92" y="384" width="316" height="22" rx="11" ry="11"/>
 <rect className="cls-1" x="196" y="131" width="40" height="238" rx="16" ry="16"/>
 <rect id="Rectangle_8_copy_2" data-name="Rectangle 8 copy 2" fill="#5d5d5e" className="cls-1" x="264" y="131" width="40" height="238" rx="16" ry="16"/>
</svg>
 );

 export const wrap1 = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect className="cls-1" x="92" y="97" width="316" height="22" rx="11" ry="11"/>
 <rect id="Rectangle_7_copy" data-name="Rectangle 7 copy" fill="#5d5d5e" className="cls-1" x="92" y="384" width="316" height="22" rx="11" ry="11"/>
 <rect className="cls-1" x="196" y="131" width="40" height="238" rx="16" ry="16"/>
 <rect id="Rectangle_8_copy_2" data-name="Rectangle 8 copy 2" fill="#5d5d5e" className="cls-1" x="264" y="131" width="40" height="238" rx="16" ry="16"/>
</svg>
 );

 export const wrap2 = (
   <svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect className="cls-1" x="92" y="97" width="316" height="22" rx="11" ry="11"/>
 <rect id="Rectangle_7_copy" data-name="Rectangle 7 copy" fill="#5d5d5e" className="cls-1" x="92" y="384" width="316" height="22" rx="11" ry="11"/>
 <rect className="cls-1" x="196" y="131" width="40" height="238" rx="16" ry="16"/>
 <rect id="Rectangle_8_copy_2" data-name="Rectangle 8 copy 2" fill="#5d5d5e" className="cls-1" x="264" y="131" width="40" height="238" rx="16" ry="16"/>
</svg>
 );

 export const HeadingIcon = (
 <svg  className="th-block-icon" xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <Text id="H" font-size='347.65px' text-anchor='middle' font-family='Comfortaa' font-weight='700' fill="#777778" className="cls-1" transform="matrix(1.184, 0, 0, 1.184, 250, 405.422)"><tspan x="0">H</tspan></Text>
 </svg>
 );

 export const ConatinerIcon = (
 <svg className="th-block-icon" xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
 <rect id="Rounded_Rectangle_10" data-name="Rounded Rectangle 10" fill="#000" className="cls-1" x="110" y="112" width="83" height="8" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy" data-name="Rounded Rectangle 10 copy" fill="#000" className="cls-1" x="110" y="112" width="8" height="83" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_2" data-name="Rounded Rectangle 10 copy 2" fill="#000" className="cls-1" x="307" y="381" width="83" height="8" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_3" data-name="Rounded Rectangle 10 copy 3" fill="#000" className="cls-1" x="382" y="306" width="8" height="83" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_6" data-name="Rounded Rectangle 10 copy 6" fill="#000" className="cls-1" x="110" y="306" width="8" height="83" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_7" data-name="Rounded Rectangle 10 copy 7" fill="#000" className="cls-1" x="110" y="381" width="83" height="8" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_4" data-name="Rounded Rectangle 10 copy 4" fill="#000" className="cls-1" x="382" y="112" width="8" height="83" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_5" data-name="Rounded Rectangle 10 copy 5" fill="#000" className="cls-1" x="307" y="112" width="83" height="8" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_8" data-name="Rounded Rectangle 10 copy 8" fill="#000" className="cls-2" x="214" y="112" width="72" height="8" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_9" data-name="Rounded Rectangle 10 copy 9" fill="#000" className="cls-2" x="110" y="214" width="8" height="72" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_10" data-name="Rounded Rectangle 10 copy 10" fill="#000" x="382" y="214" width="8" height="72" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_11" data-name="Rounded Rectangle 10 copy 11" fill="#000" x="382" y="214" width="8" height="72" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_12" data-name="Rounded Rectangle 10 copy 12" fill="#000" x="214" y="381" width="72" height="8" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_13" data-name="Rounded Rectangle 10 copy 13" fill="#000" x="214" y="246" width="72" height="8" rx="4" ry="4"/>
 <rect id="Rounded_Rectangle_10_copy_14" data-name="Rounded Rectangle 10 copy 14" fill="#000" x="246" y="214" width="8" height="72" rx="4" ry="4"/>
 </svg>
 );